import { Label, Text } from "react-aria-components";
import {
  StyledCheckbox,
  StyledCheckboxGroup,
  StyledIndicator,
  StyledCheckboxIcon,
} from "./checkbox.style";
import { MDSCheckboxProps, MDSCheckboxGroupProps, MDSCheckboxSlotName } from "./checkbox.types";
import { getSlot } from "@/mds/utils/slots";
import { MdsIconKind } from "@/design-system/components/icon";

export const MDSCheckbox = ({ children, value, ...props }: MDSCheckboxProps) => {
  return (
    <StyledCheckbox {...props} value={value}>
      {({ isSelected, isIndeterminate }) => (
        <>
          <StyledIndicator>
            <StyledCheckboxIcon
              kind={
                isIndeterminate
                  ? MdsIconKind.Checkbox
                  : isSelected
                    ? MdsIconKind.CheckboxSolid
                    : MdsIconKind.CheckboxEmpty
              }
              isSelected={isSelected || isIndeterminate}
            />
          </StyledIndicator>
          <Label>{children}</Label>
        </>
      )}
    </StyledCheckbox>
  );
};

export const MDSCheckboxGroup = ({
  children,
  label,
  description,
  errorMessage,
  ...props
}: MDSCheckboxGroupProps) => {
  return (
    <StyledCheckboxGroup {...props}>
      {label && <Label>{label}</Label>}
      {description && <Text slot="description">{description}</Text>}
      {getSlot(children, MDSCheckboxSlotName.Before)}
      {children}
      {getSlot(children, MDSCheckboxSlotName.After)}
      {errorMessage && <Text slot="errorMessage">{errorMessage}</Text>}
    </StyledCheckboxGroup>
  );
};
